import { BaseService } from "./../../base";
export class RecipeService extends BaseService {
  static get entity() {
    return "recipe";
  }
  static get name() {
    return "recipe";
  }

  /**
   *
   * @param {
   * destination*: int id del nodo de destino (ocupa los movimientos para esto)
   * patient_id: int id del paciente al que está asociado la receta
   * state: string va con el estado cuando la receta ha sido recepionada
   * validation_type_recipe_id: int es el id del tipo de validación
   * reject_type_recipe_id: int es el id del tipo de rechazo
   * } dataToFilter
   * @returns
   */
  static async getByDestination(dataToFilter, page) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_destination_filter?page=${page}`, this.name, dataToFilter);
  }
  /**
   *
   * @param {
   * origin_node_id*: int id del nodo de origen
   * patient_id: int id del paciente al que está asociado la receta
   * state: string el campo state de la receta
   * } dataToFilter
   * @returns
   */
  static async getByOrigin(dataToFilter, page) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_origin_filter?page=${page}`, this.name, dataToFilter);
  }

  static async getByOtherCenters(dataToFilter, page) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_other_centers?page=${page}`, this.name, dataToFilter);
  }

  static async getRptGetByOrigin(data) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_origin_filter_export`, null, data, {
      responseType: "blob",
    });
  }

  static async getRptGetByDestination(data) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_destination_filter_export`, null, data, {
      responseType: "blob",
    });
  }
  static async getByCorrelativeManualNumber(data) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_correlative_manual_number`, this.name, data);
  }
  static async getRemoveLastDispatchRecipe(data) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/remove_last_dispatch_recipe`, this.name, data);
  }
  static async getByPatientNoPaginate(data) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_patient_no_paginate`, this.name, data);
  }
}
